import type { Nullable } from "../@types/generic";
import { extractCountry } from "./generic";
import { getVariant6462 } from "./getVariant";
import { getWindow } from "./getWindow";
import { scheduleMicrotask } from "./scheduleMicrotask";
import {
    isPageTrackDataLayerItem,
    type DataLayerItem,
    type DataLayerItemPageTrack,
} from "./types";
import { setUserSession } from "./userSession";

export const pushDataLayer = (obj: DataLayerItem): void => {
    const window = getWindow();

    if (!window) {
        return;
    }

    scheduleMicrotask(window, () => {
        window.dataLayer = window.dataLayer ?? [];
        const type = obj.type;

        if (type === "pageTrack") {
            addVariant6462(window, obj);
            setUserSession(window, obj);
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        delete obj.type;

        // If there is no entry with pageType and pageTypeDetail, set this as first entry in the array.
        // Otherwise, just push to the end.
        if (
            type === "pageTrack" &&
            !isPageTrackDataLayerItem(window.dataLayer[0])
        ) {
            window.dataLayer.unshift(obj);
        } else {
            window.dataLayer.push(obj);
        }
    });
};

export const getPageTrackItem = (): Nullable<DataLayerItemPageTrack> => {
    const window = getWindow();
    if (isPageTrackDataLayerItem(window?.dataLayer?.[0])) {
        return window.dataLayer[0];
    }
    return null;
};

const addVariant6462 = (window: Window, obj: DataLayerItemPageTrack): void => {
    const country = extractCountry(
        window.location.hostname,
        window.location.pathname
    );

    if (country === "at") {
        obj.ab_6462 = getVariant6462(window);
    }
};
